import React from "react";

import SupportEmail from "@components/SupportEmail";

import styles from "./ApiErrorMessage.scss";

export default function ApiErrorMessage(): JSX.Element {
  return (
    <div className={styles.wrapper}>
      <h3>Sorry, We couldn't process your request</h3>
      <div>
        Please try again, if you continue to run into problems, email{" "}
        <SupportEmail isLink />.
      </div>
    </div>
  );
}
